module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./EditPromotionView.js"));
	}, "EditPromotionView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=EditPromotionView!./src/pages/Promote/BusinessCard/EditPromotion/EditPromotionView.js
// module id = 2061
// module chunks = 367